/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
import Admin from "@/views/Admin.vue";
import User from "@/views/User.vue";
import NotFound from "@/views/NotFound.vue";
import MagicToken from "@/views/MagicToken.vue";
import Campaigns from "@/views/Campaigns.vue";
import Connect from "@/views/Connect.vue"
import UserProfile from "@/components/user/UserProfile.vue";
import AdminDashboard from "@/components/admin/dashboard/AdminDashboard.vue";
import ConveyConnectDashboard from "@/components/convey-connect/dashboard/ConveyConnectDashboard.vue"
import CallActivities from "@/components/convey-connect/calls/CallActivities.vue"
import ConnectSettings from "@/components/convey-connect/settings/ConnectSettings.vue"
import AdminUsers from "@/components/admin/AdminUsers.vue";
import AdminUserList from "@/components/admin/users/AdminUserList.vue";
import AdminCreateUser from "@/components/admin/users/AdminCreateUser.vue";
import AdminEditUser from "@/components/admin/users/AdminEditUser.vue";
import AdminUserInvitations from "@/components/admin/AdminUserInvitations.vue";
import AdminUserInvitationList from "@/components/admin/invitations/AdminUserInvitationList.vue";
import AdminUserInvitationDetail from "@/components/admin/invitations/AdminUserInvitationDetail.vue";
import AdminUserRoles from "@/components/admin/AdminUserRoles.vue";
import AdminUserRoleList from "@/components/admin/roles/AdminUserRoleList.vue";
import AdminCreateUserRole from "@/components/admin/roles/AdminCreateRole.vue";
import AdminEditUserRole from "@/components/admin/roles/AdminEditRole.vue";
import AdminCallPositions from "@/components/admin/AdminCallPositions.vue";
import AdminCallPositionsList from "@/components/admin/positions/AdminCallPositionsList.vue";
import AdminCreateCallPosition from "@/components/admin/positions/AdminCreateCallPosition.vue";
import AdminEditCallPosition from "@/components/admin/positions/AdminEditCallPosition.vue";
import AdminConversations from "@/components/admin/AdminConversations.vue";
import AdminConversationList from "@/components/admin/conversations/AdminConversationList.vue";
import RecentActivities from "@/components/admin/activities/RecentActivities.vue";
import AdminConversationDetail from "@/components/admin/conversations/AdminConversationDetail.vue";
import AdminTemplates from "@/components/admin/AdminTemplates.vue";
import TemplateList from "@/components/message_templates/TemplateList.vue";
import AdminCreateTemplate from "@/components/admin/templates/AdminCreateTemplate.vue";
import AdminEditTemplate from "@/components/admin/templates/AdminEditTemplate.vue";
import AdminNumbers from "@/components/admin/AdminNumbers.vue";
import AdminNumberList from "@/components/admin/numbers/AdminNumberList.vue";
import AdminCreateNumber from "@/components/admin/numbers/AdminCreateNumber.vue";
import AdminEditNumber from "@/components/admin/numbers/AdminEditNumber.vue";
import AdminSettings from "@/components/admin/AdminSettings.vue";
import Conversations from "@/views/Conversations.vue";
import ConversationDashboard from "@/components/dashboard/Dashboard.vue";
import AdvancedConversationDetail from "@/components/AdvancedConversationDetail";
import BaseLayout from "@/layout/BaseLayout";
import CampaignHome from "@/components/campaigns/CampaignHome";
import CampaignEvents from "@/components/campaigns/CampaignEvents";
import CampaignEventsHome from "@/components/campaigns/CampaignEventsHome";
import CampaignEventDetail from "@/components/campaigns/CampaignEventDetail";
import CampaignSubscribers from "@/components/campaigns/CampaignSubscribers";
import CampaignSubscribersHome from "@/components/campaigns/CampaignSubscribersHome";
import CampaignSubscriberDetail from "@/components/campaigns/CampaignSubscriberDetail";
import CampaignSubscriberNew from "@/components/campaigns/CampaignSubscriberNew";
import CampaignDashboard from "@/components/dashboard/campaigns/CampaignDashboard.vue"
import { authGuard, moduleGuard } from "@/auth";
import store from "@/store";
import {
  CORE_ALERT_ENABLED,
  CORE_CONNECT_ENABLED,
  CORE_COMMUNICATOR_ENABLED,
} from "./constants";

Vue.use(Router);

let previousRoute = null;
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/t/:token",
      name: "MagicToken",
      component: MagicToken,
    },
    {
      path: "",
      component: BaseLayout,
      beforeEnter: authGuard,
      children: [
        {
          path: "/",
          name: "Home",
          component: Home,
          beforeEnter: moduleGuard(""),
        },
        {
          path: "/user",
          component: User,
          beforeEnter: moduleGuard(""),
          children: [
            {
              path: "",
              name: "User Home",
              component: UserProfile,
            },
            {
              path: "profile",
              name: "User Profile",
              component: UserProfile,
            },
            {
              path: "templates",
              name: "User Message Templates",
              component: TemplateList,
              props: { scope: "user" },
            },
          ],
        },
        {
          path: "/conversations",
          component: Conversations,
          beforeEnter: moduleGuard(CORE_COMMUNICATOR_ENABLED),
          children: [
            {
              path: "",
              name: "Conversations Dashboard",
              component: ConversationDashboard,
            },
            {
              path: ":conversationId",
              name: "Conversation Detail",
              component: AdvancedConversationDetail,
            },
          ],
        },
        {
          path: "/campaigns",
          component: Campaigns,
          name: "Campaigns",
          beforeEnter: moduleGuard(CORE_ALERT_ENABLED),
          children: [
            {
              path: ":campaignId",
              component: CampaignHome,
              children: [
                {
                  path: "",
                  name: "Campaign Dashboard",
                  component: CampaignDashboard,
                },
                {
                  path: "events",
                  component: CampaignEvents,
                  children: [
                    {
                      path: "",
                      name: "Campaign Events",
                      component: CampaignEventsHome,
                    },
                    {
                      path: ":campaignEventId",
                      name: "Campaign Event Detail",
                      component: CampaignEventDetail,
                    },
                  ],
                },
                {
                  path: "subscribers",
                  component: CampaignSubscribers,
                  children: [
                    {
                      path: "",
                      name: "Campaign Subscribers",
                      component: CampaignSubscribersHome,
                    },
                    {
                      path: "new",
                      name: "New Campaign Subscriber",
                      component: CampaignSubscriberNew,
                    },
                    {
                      path: ":campaignSubscriberId",
                      name: "Campaign Subscriber Detail",
                      component: CampaignSubscriberDetail,
                    },
                  ]
                }
              ],
            },
          ],
        },
        {
          path: "/connect",
          component: Connect,
          beforeEnter: moduleGuard(CORE_CONNECT_ENABLED),
          children: [
            {
              path: "",
              name: "Convey Connect Dashboard",
              component: ConveyConnectDashboard,
            },
            {
              path: "call-activities",
              name: "Convey Connect Calls",
              component: CallActivities
            },
            {
              path: "settings",
              name: "Convey Connect Settings",
              component: ConnectSettings
            },
          ],
        },    
        {
          path: "/admin",
          component: Admin,
          beforeEnter: moduleGuard(""),
          children: [
            {
              path: "",
              name: "Admin Dashboard",
              component: AdminDashboard,
            },
            {
              path: "settings",
              component: AdminSettings,
              name: "Admin Settings",
            },
            {
              path: "conversations",
              component: AdminConversations,
              children: [
                {
                  path: "",
                  component: AdminConversationList,
                  name: "Admin Conversations",
                },
                {
                  path: ":conversationId",
                  component: AdminConversationDetail,
                  name: "Admin Conversation Detail",
                },
              ],
            },
            {
              path: "recent-activities",
              component: RecentActivities,
              name: "Recent Activities",
            },
            {
              path: "call-positions",
              component: AdminCallPositions,
              children: [
                {
                  path: "",
                  component: AdminCallPositionsList,
                  name: "Admin Call Positions",
                },
                {
                  path: "new",
                  component: AdminCreateCallPosition,
                  name: "Admin Create Call Position",
                },
                {
                  path: ":positionId",
                  component: AdminEditCallPosition,
                  name: "Admin Edit Call Position",
                },
              ],
            },
            {
              path: "users",
              component: AdminUsers,
              children: [
                {
                  path: "",
                  name: "Admin Users",
                  component: AdminUserList,
                },
                {
                  path: "new",
                  name: "Admin Create User",
                  component: AdminCreateUser,
                },
                {
                  path: ":userId",
                  name: "Admin Edit User",
                  component: AdminEditUser,
                },
              ],
            },
            {
              path: "roles",
              component: AdminUserRoles,
              children: [
                {
                  path: "",
                  name: "Admin User Roles",
                  component: AdminUserRoleList,
                },
                {
                  path: "new",
                  name: "Admin Create User Role",
                  component: AdminCreateUserRole,
                },
                {
                  path: ":roleId",
                  name: "Admin Edit User Role",
                  component: AdminEditUserRole,
                },
              ],
            },
            {
              path: "invitations",
              component: AdminUserInvitations,
              children: [
                {
                  path: "",
                  name: "Admin User Invitations",
                  component: AdminUserInvitationList,
                },
                {
                  path: ":inviteId",
                  component: AdminUserInvitationDetail,
                  name: "Admin User Invitation Detail",
                },
              ],
            },
            {
              path: "numbers",
              component: AdminNumbers,
              children: [
                {
                  path: "",
                  name: "Admin Numbers",
                  component: AdminNumberList,
                },
                {
                  path: "new",
                  name: "Admin Create Number",
                  component: AdminCreateNumber,
                },
                {
                  path: ":numberId",
                  name: "Admin Edit Number",
                  component: AdminEditNumber,
                },
              ],
            },
            {
              path: "templates",
              component: AdminTemplates,
              children: [
                {
                  path: "",
                  name: "Admin Templates",
                  component: TemplateList,
                  props: { scope: "admin" },
                },
                {
                  path: "new",
                  name: "Admin Create Template",
                  component: AdminCreateTemplate,
                },
                {
                  path: ":templateId",
                  name: "Admin Edit Template",
                  component: AdminEditTemplate,
                },
              ],
            },
          ],
        },
        {
          path: "/404",
          name: "Page Not Found",
          component: NotFound
        },
        {
          path: "*",
          name: "Unknown Page",
          component: NotFound
        }
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  const isMobile = store.getters["user/isMobile"];
  if (isMobile && from.path !== to.path) {
    store.commit("user/setUserSidebarOpened", false);
  }
  previousRoute = from;
  
  next();
});

export { previousRoute };
export default router;
